module.exports = __webpack_public_path__ + "static/media/banner-cofoe@2x.63df2110.png";